import React from 'react';
import {Text, View, StyleSheet} from 'react-native';
import FontAwesome from '@react-native-vector-icons/fontawesome';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {
  colors,
  spacing,
  shadows,
  borderRadius,
  typography,
} from '../../theme/theme';

import T from '../../Components/T';
const PageHeader = () => {
  const gdata = useSelector((state: RootState) => state.gdata);
  const username = gdata.username || 'User';
  const initial = username.charAt(0).toUpperCase();

  return (
    <View style={styles.headerContainer}>
      <View style={styles.avatarContainer}>
        <Text style={styles.avatarText}>{initial}</Text>
      </View>
      <View style={styles.textContainer}>
        <View style={styles.greetingRow}>
          <Text style={styles.welcomeText}><T>Welcome back,</T></Text>
          <Text style={styles.usernameText}> {username}!</Text>
        </View>
        <View style={styles.subRow}>
          <FontAwesome name="building" size={13} color={colors.accent} style={{marginRight: 6}} />
          <Text style={styles.subtitleText}>
            {gdata.company ? `Company #${gdata.company}` : 'BlueHMS Hotel Management'}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.white,
    borderRadius: borderRadius['2xl'],
    paddingHorizontal: spacing.lg,
    paddingVertical: spacing.md,
    marginVertical: spacing.sm,
    ...shadows.md,
    borderWidth: 1,
    borderColor: colors.borderLight,
  },
  avatarContainer: {
    width: 52,
    height: 52,
    borderRadius: 26,
    backgroundColor: colors.accent,
    justifyContent: 'center',
    alignItems: 'center',
    ...shadows.colored,
  },
  avatarText: {
    color: colors.white,
    fontSize: typography.fontSize['2xl'],
    fontWeight: typography.fontWeight.bold,
  },
  textContainer: {
    marginLeft: spacing.md,
    flex: 1,
  },
  greetingRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  welcomeText: {
    fontSize: typography.fontSize.lg,
    fontWeight: typography.fontWeight.medium,
    color: colors.textSecondary,
  },
  usernameText: {
    fontSize: typography.fontSize.xl,
    fontWeight: typography.fontWeight.bold,
    color: colors.textPrimary,
  },
  subRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: spacing.xs,
  },
  subtitleText: {
    fontSize: typography.fontSize.xs,
    color: colors.darkGray,
    fontWeight: typography.fontWeight.medium,
  },
});

export default PageHeader;
